<template>
  <div class="car-availability-component">
    <div class="card card-primary">
      <div class="card-header">
        <span class="fa fa-calendar-alt mr-1"></span>
        Availability for {{ car.dropdownLabel }}
      </div>
      <div class="card-body">
        <calendar-input v-if="calendar" class="zindex-2" :options="{ inline: true, noLabel: true }" v-model="currentDate" @input="$emit('change', $event)"></calendar-input>
        <div class="legend">
          <span v-if="reservation" class="fa fa-square fa-lg text-primary"></span> This Booking
          <span class="far fa-square fa-lg"></span> Available
          <span class="fa fa-square fa-lg text-default"></span> Other Booking
          <span class="fa calendar-block-ignition fa-fw">
          </span> Ignition On
          <span class="fa calendar-block-swipe fa-fw">
          </span> Swipe On / Off
        </div>
        <div style="overflow-x: scroll;">
          <div class="calendar-display clearfix">
            <div class="clearfix">
              <div class="calendar-heading calendar-row-header calendar-corner">
                <span class="fa fa-fw fa-caret-left interactive-cursor" @click="$emit('previous')"></span>
                <span class="fa fa-fw fa-caret-right interactive-cursor" @click="$emit('next')"></span>
              </div>
              <template v-for="n in 24">
                <div class="calendar-heading calendar-row-header" :key="n">{{ n - 1 | to_calendar_time }}</div>
              </template>
            </div>
            <template v-for="(day, i) in availability">
              <div class="clearfix" :key="i">
                <div class="calendar-heading calendar-row-header">{{ day.date }}</div>
                <template v-for="(time, index) in day.times">
                  <template v-if="time && time.reservationId">
                    <component :is="blockType(links)" :class="{
                      'calendar-block-selected': time.reservationId == reservation,
                      'calendar-block-start': time.start === index,
                      'calendar-block-end': time.end === index,
                      'calendar-block-ignition': time.ignition,
                      'calendar-block-swipe': time.swipe
                    }"
                    :key="index"
                    class="calendar-col"
                    :to="{ path: `/fleet/reservations/${time.reservationUuid}` }"></component>
                  </template>
                  <template v-else>
                    <div class="calendar-col calendar-blank"
                      :key="index"
                      :class="{
                        'faded-border': index % 2 === 0,
                        'calendar-block-ignition': time && time.ignition,
                        'calendar-block-swipe': time && time.swipe
                      }">
                    </div>
                  </template>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalendarInput from '@/components/inputs/CalendarInput'

export default{
  name: 'CarAvailability',
  components: {
    CalendarInput
  },
  props: {
    car: {
      type: Object
    },
    date: {
      type: String
    },
    links: {
      type: Boolean,
      default () {
        return true
      }
    },
    reservation: {
      type: [ Number, String ]
    },
    availability: {
      type: Array
    },
    calendar: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  data () {
    return {
      currentDate: this.date
    }
  },
  methods: {
    blockType (links) {
      return links ? 'router-link' : 'span'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/CarAvailability.vue